import "./Menu.css";
import React, {useCallback} from "react";
import { Link } from 'react-router-dom';
import {Role} from "../../../Utils/enums";

const Menu = ({role}: {role: Role}) => {
    const clearCache = useCallback(() => {
        // eslint-disable-next-line no-restricted-globals
    //     const confirmed = confirm("Do you really want to remove all cached files and category data? This action cannot be undone!");
    //     if (confirmed) {
    //         clearAllCache().then(resp => {
    //             if (resp.errorCode !== undefined) {
    //                 alert(`Error: ${resp.errorCode}`);
    //             } else {
    //                 if (resp.success) {
    //                     alert("All the cache successfully deleted!");
    //                 }
    //             }
    //         });
    //     }
    }, [role])

    return (
        <div className="main-content">
            <div className="menu-main">
                <div className="menu-container">
                    <LinkButton path="/kw-csi-assign" text="Assign CSI with keywords"/>
                    <LinkButton path="/ai-csi-assign" text="Assign CSI with AI"/>
                    {role === Role.Administrator || role === Role.SuperAdmin?
                        <>
                        <LinkButton path="/admin-users" text="Admin Panel: Users"/>
                        <LinkButton path="/admin-keywords" text="Admin Panel: Keywords"/>
                        {false && role === Role.SuperAdmin?
                            <FakeLinkButton text="Clear All Cache" action={clearCache}/> : <></>}
                        </>
                         : <></>}
                </div>
            </div>
        </div>
    );
};

const LinkButton = ({path, text}: {path: string, text: string}) => {
    return (
        <Link className="link" to={path}>
            <p className="link-button-text">{text}</p>
        </Link>
    );
}

const FakeLinkButton = ({text, action}: {text: string, action: () => void}) => {
    return (
        <div className="link" style={{cursor: "pointer"}} onClick={action}>
            <p className="link-button-text">{text}</p>
        </div>
    );
}

export default Menu;
